import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import { Icon, IconArrowUpL, IconArrowDownL } from '@flixbus/honeycomb-icons-react';
import { Dropdown, DropdownItem } from '@flixbus/honeycomb-react';

import { crewMemberActionLogStore } from 'pages/CrewMemberDetails/components/CrewMemberActionLog/CrewMemberActionLogStore';

import { getUtcDateRangesCrewLogFilter } from './utils';

import styles from './styles.module.css';

const CrewLogDateRangeFilter = observer(() => {
	const [arrowUp, setArrowUp] = useState(false);
	const { filterDaterange, setSelectedDaterange } = crewMemberActionLogStore;

	const toggleArrowButton = (isActive) => {
		setArrowUp(isActive);
	};

	const handleSelection = (e, type) => {
		e.preventDefault();
		setSelectedDaterange(type);
		toggleArrowButton();
	};

	const linkArray = getUtcDateRangesCrewLogFilter().map(({ name, value }) => (
		<DropdownItem
			Elem="a"
			href=""
			active={name === filterDaterange.name}
			onClick={(e) => handleSelection(e, { value, name })}
			key={name}
		>
			{name}
		</DropdownItem>
	));

	return (
		<Dropdown
			active={arrowUp}
			links={linkArray}
			onToggle={toggleArrowButton}
			yPosition="bottom"
			xPosition="right"
		>
			<div className={styles.spaced}>
				<div className={styles.text}>
					<div className={styles.contain}>{filterDaterange.name}</div>
				</div>
				<Icon
					extraClasses={styles.icon}
					InlineIcon={arrowUp ? IconArrowUpL : IconArrowDownL}
					size={3}
				/>
			</div>
		</Dropdown>
	);
});

export default CrewLogDateRangeFilter;
